module.exports = __webpack_public_path__ + "media/images/weather/255_night-6a8417d20cb0978fc73c2c20a42fa69c.png";